<template>
  <a-scene embedded fog="type: linear; color: #000; far: 10;">
    <!-- Preload all the assets -->
    <a-assets>
      <img id="floor" src="@/assets/marble.jpg" />
      <img id="wall-texture" src="@/assets/drywall.jpg" />
      <img id="frame" src="@/assets/wood.jpg" />
    </a-assets>

    <!-- Setup the room, lights, and camera -->
    <VrEnvironment
      trim="#frame"
      wall="#wall-texture"
      floor="#floor"
    ></VrEnvironment>

    <VrStereoView
      :img="img"
      :rcoords="rcoords"
      :lcoords="lcoords"
    ></VrStereoView>
  </a-scene>
</template>

<script>
import "aframe";
import "@/libs/aframe-stereo-component.min.js";
import VrStereoView from "@/components/VrStereoView.vue";
import VrEnvironment from "@/components/VrEnvironment.vue";
export default {
  name: "VrViewer",

  components: {
    VrStereoView,
    VrEnvironment,
  },
  props: {
    img: {
      type: String,
    },
    lcoords: {
      type: String,
    },
    rcoords: {
      type: String,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
